export default __webpack_public_path__ + "static/trustbadge-668f0a3e173028e509aed05ae1cd68b3.png";